import {Box} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import ToggleCard from './toggle-card.jsx';

const ThumbnailCard = ({thumbnail, children, sx, button = false, ...props}) => {
  return (
    <ToggleCard
      sx={{
        borderWidth: 2,
        position: 'relative',
        ...(props.disabled
          ? {
              backgroundColor: 'action.disabledBackground',
              opacity: 0.38,
            }
          : {}),
        ...sx,
      }}
      button={button}
      {...props}
    >
      <Box
        sx={{
          padding: 0.5,
          flexShrink: 0,
          height: '100%',
        }}
      >
        {thumbnail}
      </Box>
      {children}
    </ToggleCard>
  );
};

ThumbnailCard.propTypes = {
  selected: PropTypes.bool,
  thumbnail: PropTypes.object.isRequired,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  sx: PropTypes.object,
  button: PropTypes.bool,
};

export default ThumbnailCard;
